import { useState, useEffect } from "react";

export const useBatchRenderedList = (dataList, batchSize=10) => {
    const [batchList, setBatchList] = useState([])

    useEffect(() => {
        const batchRender = (dataLength, startIndex, endIndex, batchSize) => {
            console.log("dataLength:", dataLength, "startIndex:", startIndex, "endIndex:", endIndex, "batchSize:", batchSize)
            setBatchList(prev => [...prev, ...dataList.slice(startIndex, endIndex)])
            if (endIndex < dataLength) {
                setTimeout(() => {
                    batchRender(dataList.length, endIndex, endIndex + batchSize, batchSize)
                }, 100)
            }
        }
        dataList && batchRender(dataList.length, 0, batchSize, batchSize)
    // eslint-disable-next-line
    }, [])

    return batchList
}
